import { Typography } from '@mui/material';
import * as React from 'react';

export const ProfessionalVisitsPage: React.FunctionComponent = () => {
    return <Typography>ProfessionalVisits page: Work in progress</Typography>;
};
